import React from "react";
import { useModalAnimation } from "../../hooks/animation/useModalAnimation";
import { useUiRedux } from "../../hooks/useUiRedux";
import { copysInformationModal } from "../../types/copysInformation";
import { modalLearnMore } from "../../types/imagesModal";
import { modalInformation } from "../../types/initStore/initUi";
import { ButtonPrimary } from "../Button/ButtonPrimary";

export const ModalInformation = () => {
	const {
		state: { activeModal, selectCardMenu, nameHeaderCardContainer },
		closeModalCard,
		viewImageModal,
	} = useUiRedux();
	const { container } = useModalAnimation(activeModal);
	const dataInformation = {
		...modalInformation,
		name: nameHeaderCardContainer,
		icon: selectCardMenu.icon,
		background: selectCardMenu.background,
		nameTitle: nameHeaderCardContainer,
		description: selectCardMenu.findCopyInformation === "" ? null : copysInformationModal[selectCardMenu.findCopyInformation],
		learnMore: selectCardMenu.findCopyInformation === "" ? [] : modalLearnMore[selectCardMenu.findCopyInformation],
	};
	return (
		<div
			ref={container}
			className="absolute z-20 h-full w-full bg-secondary_white justify-center items-center px-10 sm:px-24 pt-24 pb-16 lg:py-0 lg:px-0 opacity-0 hidden"
		>
			<div className="w-full h-full lg:h-[700px] lg:w-[450px] overflow-hidden grid grid-rows-containerInformation text-white rounded-lg">
				<div className="bg-black_two overflow-y-auto">
					<div className="bg-blue_black h-[60%] px-6 py-6 flex flex-col gap-2 lg:gap-6 overflow-y-auto">
						<div className="">
							<div
								style={{ backgroundImage: `url(${dataInformation.background})` }}
								className={` bg-center h-[100px] lg:h-[120px] rounded-lg bg-cover bg-no-repeat`}
							>
								<div className="h-full flex flex-col justify-center items-center text-white">
									<img className="h-[30px] w-[30px]" src={dataInformation.icon} alt="icon" />
									<span className="xsm:text-[10px] lg:text-[17px]">{dataInformation.name}</span>
								</div>
							</div>
						</div>
						<div className="flex flex-col gap-2">
							<h2>{dataInformation.nameTitle}</h2>
							<div className="text-[12px] lg:text-[13px] lightFont">{dataInformation.description}</div>
						</div>
					</div>
					<div className="h-[40%] px-6 py-6 flex flex-col gap-3">
						<div>
							<span className="text-[13px] lg:text-[16px]">Conoce tus estaciones de trabajo</span>
						</div>
						<div className="grid grid-cols-2 gap-2">
							{dataInformation.learnMore.map((learn, index) => (
								<img
									key={`${index}-imagenmodal`}
									className="h-full w-full cursor-pointer"
									src={learn.image}
									alt="conoce_mas"
									onClick={() => {
										viewImageModal(learn.image);
									}}
								/>
							))}
						</div>
					</div>
				</div>
				<div className="px-3 py-6 lg:px-32 bg-blue_black">
					<ButtonPrimary
						name="Cerrar información"
						action={() => {
							closeModalCard();
						}}
					/>
				</div>
			</div>
		</div>
	);
};
